import { ReactComponent as FlagIcon } from "./svg/id-flag.svg";
import "../flag-icon.scss";

export const IDFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
